import React, { useContext } from 'react';

import Button from '@material-ui/core/Button';
import CancelRequestButton from './CancelRequestButton/CancelRequestButton';
import CancelReservationButton from './CancelReservationButton/CancelReservationButton';
import { CircularProgress } from '@material-ui/core';
// STYLE
import Grid from '@material-ui/core/Grid';
// HOOKS
import HoldingsTableOperationColumnRequestItemButton from './HoldingsTableOperationColumnRequestItemButton/HoldingsTableOperationColumnRequestItemButton';
import HoldingsTableOperationColumnReserveItemButton from './HoldingsTableOperationColumnReserveItemButton/HoldingsTableOperationColumnReserveItemButton';
import { MyTransactionContext } from '../../../context/myTransactionContext';
import ViewMyRequestButton from './ViewMyRequestButton/ViewMyRequestButton';
import ViewMyReservationButton from './ViewMyReservationButton/ViewMyReservationButton';
import { navigate } from 'gatsby';
import { SystemStatusContext } from '../../../providers/SystemStatusProvider';
import { controlledFeatures } from '../../../utils/featureControl';

const HoldingsTableOperationColumn = props => {
  const { item = {}, me, setReservationData, setRequestData } = props;
  const { hasActiveLoan, hasReservation, hasRequests } = item ?? {};

  const { data, loading } = useContext(MyTransactionContext);
  const { maintenance } = useContext(SystemStatusContext);

  if (loading) {
    return <CircularProgress color={'primary'} size={15} />;
  }

  const isBorrowable =
    item?.calculatedItemPolicyForPatron?.rules?.find(
      rule => rule.ruleType === 'IS_BORROWABLE'
    )?.ruleValue === 'true';

  const isReservable =
    item?.calculatedItemPolicyForPatron?.rules?.find(
      rule => rule.ruleType === 'IS_RESERVEABLE'
    )?.ruleValue === 'true';

  const isRequestable =
    item?.calculatedItemPolicyForPatron?.rules?.find(
      rule => rule.ruleType === 'IS_BOOKABLE'
    )?.ruleValue === 'true';

  const getContent = () => {
    if (!controlledFeatures.loan) {
      return null;
    }

    if (!sessionStorage.getItem('accessToken') && controlledFeatures.login) {
      return (
        <Button
          color="primary"
          onClick={() =>
            navigate('/bejelentkezes', { state: { navigateBack: true } })
          }
          variant="outlined"
          size="small"
          disabled={maintenance}
        >
          Bejelentkezés
        </Button>
      );
    }

    if (!isBorrowable) {
      return 'Nem kölcsönözhető';
    }

    if (!isRequestable && !isReservable) {
      return 'Nem foglalható/előjegyezhető';
    }

    const loanOnItemByUser = data?.myActiveLoans?.find(
      loan => loan.item.guid === item.guid
    );

    const reservationOnItemByUser = data?.myActiveReservations?.find(
      reservation => reservation.targetItem.guid === item.guid
    );

    const requestOnItemByUser = data?.myActiveRequests?.find(request => {
      return request.item?.guid === item.guid;
    });

    if (loanOnItemByUser) {
      return 'Kikölcsönözve';
    }

    if (reservationOnItemByUser) {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
          <ViewMyReservationButton
            reservationOnItemByUser={reservationOnItemByUser}
            setReservationData={setReservationData}
          />
          <CancelReservationButton guid={reservationOnItemByUser?.guid} />
        </div>
      );
    }

    if (requestOnItemByUser) {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
          <ViewMyRequestButton
            requestOnItemByUser={requestOnItemByUser}
            setRequestData={setRequestData}
          />
          <CancelRequestButton guid={requestOnItemByUser?.id} />
        </div>
      );
    }

    if (isRequestable) {
      if (hasActiveLoan || hasReservation || hasRequests) {
        return <HoldingsTableOperationColumnRequestItemButton item={item} />;
      }
      // AKKOR LEHET CSAK FOGLALNI HA NINCS AKTÍV KÖLCSÖNZÉS / FOGLALÁS VAGY ELŐJEGYZÉS
      // return <HoldingsTableOperationColumnReserveItemButton item={item} />;
    }

    if (isReservable && !hasActiveLoan && !hasReservation && !hasRequests) {
      return <HoldingsTableOperationColumnReserveItemButton item={item} />;
    }

    // return <HoldingsTableOperationColumnRequestItemButton item={item} />;
    return null;
  };

  return (
    <Grid container alignItems="center" justifyContent="center">
      <Grid item>{getContent()}</Grid>
    </Grid>
  );
};

export default HoldingsTableOperationColumn;
